function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.75 12.5c-.703 0-1.25.586-1.25 1.25 0 2.07-1.719 3.75-3.75 3.75H9.5v-1.563a.881.881 0 0 0-.586-.82c-.312-.156-.703-.117-1.016.156l-3.125 2.813c-.195.156-.273.43-.273.664 0 .273.078.547.273.703l3.125 2.813c.196.156.43.234.665.234.117 0 .234 0 .351-.078.352-.117.586-.469.586-.86V20h6.25A6.243 6.243 0 0 0 22 13.75c0-.664-.586-1.25-1.25-1.25Zm-12.5-5h6.21l.04 1.563c0 .39.195.742.547.859.117.078.234.078.351.078.196 0 .43-.078.625-.234l3.125-2.813a.835.835 0 0 0 .352-.703c0-.313-.117-.547-.313-.703l-3.125-2.813a.898.898 0 0 0-1.015-.156c-.352.156-.586.508-.586.86L14.5 5H8.25A6.243 6.243 0 0 0 2 11.25c0 .703.547 1.25 1.25 1.25.664 0 1.25-.547 1.25-1.25 0-2.031 1.68-3.75 3.75-3.75Z"
});

function SvgRepeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.af4b3bbe.svg";
export { ForwardRef as ReactComponent };